import { useEffect, useState } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { Typography, Grid, Box, Button } from '@material-ui/core'
import styles from '../dashboardStyles'

import Group3 from '../../../../../ui-assets/Group3.svg'
import Group4 from '../../../../../ui-assets/Group4.svg'
import Group5 from '../../../../../ui-assets/Group5.svg'
import Group5A from '../../../../../ui-assets/Group5A.svg'
import Group6 from '../../../../../ui-assets/Group6.svg'
import Group7 from '../../../../../ui-assets/Group7.svg'
import Group7A from '../../../../../ui-assets/Group7A.svg'
import Group8 from '../../../../../ui-assets/Group8.svg'
import Group9 from '../../../../../ui-assets/Group9.svg'
import Group10 from '../../../../../ui-assets/Group10.svg'

import handleOutBoundHangup from '../../../../../helpers/handleOutBoundHangup'
import { callTransferDepartmentInfo } from '../../../../../helpers/callTransferDetails'

import TransferCall from './TransferCall'


const DailPad = ({
    classes,
    customerPhoneNumber,
    dispatch,
    timer,
    isCallActive,
    showTransfer,
    transferStatus,
    handleTransferStatus,
    isCallHangUp,
    handleTransferText
}) => {

    const [muteToggle, setMuteToggle] = useState(false)
    const [holdToggle, setHoldToggle] = useState(false)



    const formattedNumber = `${String(customerPhoneNumber).substring(0, 3)} ${String(customerPhoneNumber).substring(3, 6)} ${String(customerPhoneNumber).substring(6, 10)}`;

    useEffect(() => {
        let interval
        if (isCallActive) {
            interval = setInterval(() => {
                dispatch({ type: 'SET_CALL_TIMER' })
            }, 1000)
        } else {
            clearInterval(interval)
        }
        return () => clearInterval(interval)
    }, [isCallActive])

    useEffect(() => {
        if (isCallActive === false) {
            dispatch({
                type: 'SET_CALL_DURATION',
                payload: timer
            })
        }
    }, [isCallActive])

    // Function to format time in HH:MM:SS
    const formatTime = (timeInSeconds) => {
        let hours = Math.floor(timeInSeconds / 3600)
        let minutes = Math.floor((timeInSeconds - (hours * 3600)) / 60)
        let seconds = timeInSeconds - (hours * 3600) - (minutes * 60)

        // Pad with 0 if needed
        hours = hours < 10 ? '0' + hours : hours
        minutes = minutes < 10 ? '0' + minutes : minutes
        seconds = seconds < 10 ? '0' + seconds : seconds

        return `${hours}:${minutes}:${seconds}`
    }
    // Updated the SIP function to use async/await and added error handling - 15/10/24 - Dev Srini
    const handleMuteAndUnMuteCall = async () => {
        const newMuteToggle = !muteToggle
        setMuteToggle(newMuteToggle)

        try {
            await window.sipToggleMute()
            console.log(newMuteToggle ? "Call is muted." : "Call is unmuted.")
        }
        catch(error) {
            console.error('Error during SIP Mute:', error)
        }
    }

    const handleHoldAndResumeCall = async () => {
        const newHoldToggle = !holdToggle
        setHoldToggle(newHoldToggle)

        try {
            await window.sipToggleHoldResume()
            console.log(newHoldToggle ? "Call is on hold." : "Call has resumed.")
        }
        catch(error) {
            console.error('Error during SIP Hold/Resume:', error)
        }
    }

    const callTransfer = () => {
        callTransferDepartmentInfo(dispatch)

        dispatch({
            type: 'SET_SHOW_TRANSFER',
            payload: true
        })
    }

    return (
        <div style={{ flex: '25%', }}>
            <div className={classes.lastcall_infolayout}
                style={{
                    width: '305px',
                    marginLeft: '25px',
                    marginTop: '12px',
                    display: 'flex'
                }}
            >

                <div style={{ flex: 1 }}>
                    <Typography className={classes.lastcall_text} style={{ marginLeft: '23px', marginTop: '9px' }}>Last Call</Typography>

                    <Typography className={classes.lastcall_text} style={{ margin: '4% 0 0 14%' }}>+91 ----------</Typography>
                </div>

                <div style={{ flex: 1 }}>
                    <Typography className={classes.lastcall_text} style={{ marginLeft: '70px', marginTop: '9px' }}>Time</Typography>
                    <Typography className={classes.lastcall_text} style={{ margin: '4% 0 0 46%' }}>00:00:00</Typography>
                </div>

            </div>

            <div className={classes.mobilecard} style={{ borderRadius: '6px', marginLeft: '25px' }}>
                <div className={classes.mobilecard2} >

                    <Typography className={classes.ongoingtext}>Ongoing call</Typography>
                    <Typography className={classes.ongoingtext2}>{customerPhoneNumber ? `+91 ${formattedNumber}` : `+91 ----------`} </Typography>
                    <img src={Group3} alt='phone icon' style={{ paddingTop: '18px', paddingLeft: '100px' }} />
                    <Typography className={classes.ongoingtext3}>{formatTime(timer)}</Typography>
                </div>

                {!showTransfer ? (
                    <span>
                        <div style={{ marginTop: '25px' }}>
                            <div style={{ marginBottom: '15px' }}>
                                <Grid container spacing={1}>
                                    <Grid item xs={4} className={classes.imageContainer}>
                                        <img src={Group4} alt="Video icon" className={classes.image} />
                                    </Grid>
                                    <Grid
                                        item xs={4}
                                        className={classes.containerWrapper}
                                        onClick={handleMuteAndUnMuteCall}
                                    >
                                        {muteToggle ? (
                                            <img
                                                src={Group5A}
                                                alt="Voice Mute icon"
                                                className={classes.image}
                                            />
                                        ) : (
                                            <img
                                                src={Group5}
                                                alt="Voice Mute icon"
                                                className={classes.image}
                                            />
                                        )}
                                    </Grid>
                                    <Grid item xs={4} className={classes.containerWrapper}>
                                        <div className={classes.imageContainer}>
                                            <img src={Group6} alt="Music icon" className={classes.image} />
                                        </div>
                                    </Grid>
                                </Grid>
                            </div>

                            <Grid container spacing={1}>
                                <Grid
                                    item xs={4}
                                    className={classes.containerWrapper}
                                    onClick={handleHoldAndResumeCall}
                                >
                                    {holdToggle ? (
                                        <img
                                            src={Group7A}
                                            alt="Call Hold icon"
                                            className={classes.image}
                                        />
                                    ) : (
                                        <img
                                            src={Group7}
                                            alt="Call Hold icon"
                                            className={classes.image}
                                        />
                                    )}
                                </Grid>
                                <Grid item xs={4} className={classes.containerWrapper}>
                                    <div className={classes.imageContainer}>
                                        <img src={Group8} alt="Dial icon" className={classes.image} />
                                    </div>
                                </Grid>
                                <Grid item xs={4} className={classes.containerWrapper}>
                                    <div className={classes.imageContainer}>
                                        <img src={Group9} alt="Forward icon" className={classes.image} />
                                    </div>
                                </Grid>
                            </Grid>
                        </div>

                        <div className={classes.mobilecard3} style={{ display: 'flex', marginLeft: '5px', marginTop: '30px', }}>

                            <img src={Group10} alt='cancel icon' style={{ margin: '6px 0 4px 6px', cursor: 'pointer' }} onClick={() => handleOutBoundHangup(dispatch)} />

                            <Button
                                className={!isCallHangUp || transferStatus ? classes.transferCallButtonDisable : classes.transferCallButton}
                                onClick={callTransfer}
                                disabled={!isCallHangUp || transferStatus}

                            >
                                <Typography
                                    className={classes.transferCallText}
                                >
                                    Transfer Call
                                </Typography>
                            </Button>
                        </div>
                    </span>
                ) : (
                    <span>
                        <TransferCall
                            handleTransferStatus={handleTransferStatus}
                            handleTransferText={handleTransferText}
                        />
                    </span>
                )
                }
            </div>
        </div>

    )
}

export default withStyles(styles)(DailPad)